import { PageNavigationItem } from '../../../components/Navigation/PageNavigation/PageNavigation';

export const PLACE_SUB_LINK_IDS = {
  MAP: 'pl-map',
  GENERAL_INFO: 'pl-generalInfo',
  TOP_SPECIES: 'pl-topSpecies',
  FISHING_REPORTS: 'pl-fishingReports',
  FISHING_REGULATIONS: 'pl-fishingRegulations',
  FISHING_SPOTS: 'pl-fishingSpots',
  NEARBY_CITIES: 'pl-nearbyCities',
  WEATHER: 'pl-weather',
  FAQ: 'pl-faq',
  EXPLORE_MORE: 'pl-explore-more',
};

export function getPlaceSubNavLinks({
  hasSpecies,
  hasCatches,
  hasFishingSpots,
  hasRegulations,
  hasNearbyCities,
}: {
  hasSpecies: boolean;
  hasCatches: boolean;
  hasFishingSpots: boolean;
  hasRegulations: boolean;
  hasNearbyCities: boolean;
}): PageNavigationItem[] {
  return [
    { id: PLACE_SUB_LINK_IDS.MAP, label: 'Map', orderMobile: 1, orderTablet: 1 },
    ...(hasFishingSpots
      ? [
          {
            id: PLACE_SUB_LINK_IDS.FISHING_SPOTS,
            label: 'Fishing spots',
            orderMobile: 2,
            orderTablet: 4,
          },
        ]
      : []),
    ...(hasSpecies
      ? [
          {
            id: PLACE_SUB_LINK_IDS.TOP_SPECIES,
            label: 'Top species',
            orderMobile: 3,
            orderTablet: 3,
          },
        ]
      : []),
    ...(hasCatches
      ? [
          {
            id: PLACE_SUB_LINK_IDS.FISHING_REPORTS,
            label: 'Fishing reports',
            orderMobile: 4,
            orderTablet: 5,
          },
        ]
      : []),
    { id: PLACE_SUB_LINK_IDS.GENERAL_INFO, label: 'General info', orderMobile: 5, orderTablet: 2 },
    { id: PLACE_SUB_LINK_IDS.WEATHER, label: 'Weather', orderMobile: 6, orderTablet: 6 },
    ...(hasRegulations
      ? [
          {
            id: PLACE_SUB_LINK_IDS.FISHING_REGULATIONS,
            label: 'Regulations',
            orderMobile: 7,
            orderTablet: 7,
          },
        ]
      : []),
    { id: PLACE_SUB_LINK_IDS.FAQ, label: 'FAQ', orderMobile: 8, orderTablet: 8 },
    ...(hasNearbyCities
      ? [
          {
            id: PLACE_SUB_LINK_IDS.NEARBY_CITIES,
            label: 'Nearby cities',
            orderMobile: 9,
            orderTablet: 9,
          },
        ]
      : []),
    {
      id: PLACE_SUB_LINK_IDS.EXPLORE_MORE,
      label: 'Explore more',
      orderMobile: 10,
      orderTablet: 10,
    },
  ];
}
